<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="100px"
  >
    <el-form-item
      label="权限维度"
      prop="dimensionId"
    >
      <el-select
        v-model="form.dimensionId"
        clearable
        placeholder="权限维度"
        style="width: 100%"
      >
        <el-option
          v-for="item in dimensionList"
          :key="item.id"
          :label="item.dimensionName"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      prop="tableName"
      label="维度表名称"
    >
      <el-input
        placeholder="维度表名称"
        v-model="form.tableName"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="columnName"
      label="维度表字段"
    >
      <el-input
        placeholder="维度表字段"
        v-model="form.columnName"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="remark"
      label="备注"
    >
      <el-input
        placeholder="请输入"
        v-model="form.remark"
      ></el-input>
    </el-form-item>

  </el-form>
</template>

<script>
import { queryDimensionList } from '@/api/sys/dataPermission/tableList'
let origin = {
  id: '',
  dimensionId: 1,
  tableName: '',
  columnName: '',
  remark: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "tableForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {};
      }
    }
  },
  data() {
    return {
      dimensionList: [],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        dimensionId: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        tableName: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        columnName: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue){
          // this.assigen(newValue);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mixins: [formLabalPosition],
  created(){
    this.getDimensionList();
  },
  methods: {
    getDimensionList(){
      queryDimensionList().then((res) => {
        this.dimensionList = res.page.list;
      })
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(tableListItem){
      this.form.id = tableListItem.id;
      this.form.dimensionId = tableListItem.dimensionId;
      this.form.tableName = tableListItem.tableName;
      this.form.columnName = tableListItem.columnName;
      this.form.remark = tableListItem.remark;
    },

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
